
import { useContext, useEffect } from 'react';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import StatistiquesAujourdhui from '../../components/statistiques/statistiquesAujourdhui/StatistiquesAujourdhui';
import './home.css';
import { AuthContext } from '../../context/authContext/AuthContext';
import { Link } from 'react-router-dom';
import { InfopersonContext } from '../../context/infopersonContext/InfopersonContext';

function Home() {
  //test2
  const { user } = useContext(AuthContext);
  const { dispatch: dispatchInfoPerson } = useContext(InfopersonContext);

  useEffect(() => {
    dispatchInfoPerson({
      type: "CLEAR_FETCH_ERROR",
    })
  }, [])

  return (
    <div className='container-global'>
      <AdminSideBar activeTab="home" />
      <div className='center'>
        <div className="title">
          <span className="material-symbols-rounded">shoppingmode</span>
          <span>Dashboard</span>
        </div>
        
        <div className='box-success' style={{ "maxWidth": "none", "margin": "0 0 20px" }}>Pour toutes informations, contactez-nous au {user.telephone}</div>

        <StatistiquesAujourdhui />
      </div>
    </div>
  )
}
export default Home
